module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.bf59c687.ttf";